import React from 'react';

//import icons
import {BiWifi, BiDish, BiBed} from 'react-icons/bi'

const House = ({house}) => {
  const {image, type, country, address, wifi, food, bed, price} = house;
  return (
  <div className='bg-white shadow-1 p-5 rounded-lg rounded-t1-[90px] w-full max-w-[352px] mx-auto cursor-pointer hover:shadow-2xl transition'>
    <img className='mb-8' src={image} alt=''/>
    <div className='mb-4 flex gap-x-2 text-sm'>
      <div className='bg-green-500 rounded-full text-white px-3'>{type}</div>
      <div className='bg-violet-500 rounded-full text-white px-3'>{country}
      </div>
    </div>
    <div className='text-lg font-semibold max-w-[260px]'>{address}</div>
    <div className='flex gap-x-4 my-4'>
      <div className='flex items-center text-gray-600 gap-1'>
        <div className='text-[20px]'>
          <BiWifi/>
        </div>
        <div>{wifi}</div>
      </div>
      <div className='flex items-center text-gray-600 gap-1'>
        <div className='text-[20px]'>
          <BiDish/>
        </div>
        <div>{food}</div>
      </div>
      <div className='flex items-center text-gray-600 gap-1'>
        <div className='text-[20px]'>
          <BiBed/>
        </div>
        <div>{bed}</div>
      </div>
      
    </div>
    <div className='text-lg font-semibold text-violet-600 mb-4'>{price}</div>
  </div>
  );
};

export default House;
